import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.concat.js";
import layoutHeaderAside from '@/layout/header-aside';

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
var _import = require('@/libs/util.import.' + process.env.NODE_ENV);

/**
 * 在主框架内显示
 */
var frameIn = [{
  path: '/',
  redirect: {
    name: 'index'
  },
  component: layoutHeaderAside,
  children: [
  // 首页
  {
    path: '/change_pwd',
    name: 'change_pwd',
    meta: {
      auth: true,
      title: '修改密码'
    },
    component: function component() {
      return import('@/pages/admin/pwd');
    }
  },
  // 首页
  {
    path: '/index',
    name: 'index',
    meta: {
      auth: true
    },
    component: _import('system/index')
  },
  //管理员
  {
    path: '/admin',
    name: 'admin',
    component: function component() {
      return import('@/pages/admin/index');
    },
    meta: {
      auth: true,
      title: '管理员列表'
    }
  }, {
    path: '/admin_form',
    name: 'admin_form',
    component: function component() {
      return import('@/pages/admin/form');
    },
    meta: {
      auth: true,
      cache: true,
      title: '编辑管理员'
    }
  }, {
    path: '/role',
    name: 'role',
    component: function component() {
      return import('@/pages/role/index');
    },
    meta: {
      auth: true,
      title: '角色列表'
    }
  }, {
    path: '/role/add',
    name: 'role_add',
    component: function component() {
      return import('@/pages/role/add');
    },
    meta: {
      auth: true,
      cache: true,
      title: '添加角色'
    }
  }, {
    path: '/role/edit',
    name: 'role_edit',
    component: function component() {
      return import('@/pages/role/edit');
    },
    meta: {
      auth: true,
      cache: true,
      title: '编辑角色'
    }
  }, {
    path: '/log',
    name: 'log_index',
    component: function component() {
      return import('@/pages/log/index');
    },
    meta: {
      auth: true,
      title: '操作日志'
    }
  },
  //项目管理
  {
    path: '/project',
    name: 'project',
    component: function component() {
      return import('@/pages/project/index');
    },
    meta: {
      auth: true,
      cache: true,
      title: '大项管理'
    }
  }, {
    path: '/project/save',
    name: 'project_save',
    component: function component() {
      return import('@/pages/project/save');
    },
    meta: {
      auth: true,
      cache: true,
      title: '大项编辑'
    }
  },
  //小项管理
  {
    path: '/project_item',
    name: 'project_item',
    component: function component() {
      return import('@/pages/project_item/index');
    },
    meta: {
      auth: true,
      cache: true,
      title: '小项管理'
    }
  }, {
    path: '/project_item_save',
    name: 'project_item_save',
    component: function component() {
      return import('@/pages/project_item/save');
    },
    meta: {
      auth: true,
      cache: true,
      title: '小项编辑'
    }
  },
  //区域管理
  {
    path: '/area',
    name: 'area_index',
    component: function component() {
      return import('@/pages/area/index');
    },
    meta: {
      auth: true,
      cache: true,
      title: '区域管理'
    }
  }, {
    path: '/area/save',
    name: 'area_save',
    component: function component() {
      return import('@/pages/area/save');
    },
    meta: {
      auth: true,
      cache: true,
      title: '区域编辑'
    }
  },
  //单位管理
  {
    path: '/team',
    name: 'team',
    component: function component() {
      return import('@/pages/team/index');
    },
    meta: {
      auth: true,
      cache: true,
      title: '单位管理'
    }
  }, {
    path: '/team/save',
    name: 'team_save',
    component: function component() {
      return import('@/pages/team/save');
    },
    meta: {
      auth: true,
      cache: true,
      title: '单位编辑'
    }
  },
  //单位注册时间管理
  {
    path: '/team/register_config',
    name: 'team_register_config',
    component: function component() {
      return import('@/pages/team/register_config');
    },
    meta: {
      auth: true,
      cache: true,
      title: '注册时间管理'
    }
  }, {
    path: '/team_register_config/save',
    name: 'team_register_config_save',
    component: function component() {
      return import('@/pages/team/register_config_save');
    },
    meta: {
      auth: true,
      cache: true,
      title: '注册时间编辑'
    }
  },
  //错误快捷
  {
    path: '/athletes_error_type',
    name: 'athletes_error_type',
    component: function component() {
      return import('@/pages/athletes_error_type/index');
    },
    meta: {
      auth: true,
      cache: true,
      title: '错误快捷管理'
    }
  }, {
    path: '/athletes_error_type/save',
    name: 'athletes_error_type_save',
    component: function component() {
      return import('@/pages/athletes_error_type/save');
    },
    meta: {
      auth: true,
      cache: true,
      title: '错误快捷编辑'
    }
  },
  //领队管理
  {
    path: '/leader',
    name: 'leader',
    component: function component() {
      return import('@/pages/leader/index');
    },
    meta: {
      auth: true,
      cache: true,
      title: '领队管理'
    }
  }, {
    path: '/leader/save',
    name: 'leader_save',
    component: function component() {
      return import('@/pages/leader/save');
    },
    meta: {
      auth: true,
      cache: true,
      title: '领队编辑'
    }
  },
  //教练管理
  {
    path: '/coach',
    name: 'coach',
    component: function component() {
      return import('@/pages/coach/index');
    },
    meta: {
      auth: true,
      cache: true,
      title: '教练管理'
    }
  }, {
    path: '/coach/save',
    name: 'coach_save',
    component: function component() {
      return import('@/pages/coach/save');
    },
    meta: {
      auth: true,
      cache: true,
      title: '教练编辑'
    }
  },
  //教练迁移管理
  {
    path: '/coach_replace',
    name: 'coach_replace',
    component: function component() {
      return import('@/pages/coach_replace/index');
    },
    meta: {
      auth: true,
      cache: true,
      title: '教练变更注册单位管理'
    }
  }, {
    path: '/coach_replace/save',
    name: 'coach_replace_save',
    component: function component() {
      return import('@/pages/coach_replace/save');
    },
    meta: {
      auth: true,
      cache: true,
      title: '教练变更注册单位详情'
    }
  },
  //注册开放管理
  {
    path: '/sign_config',
    name: 'sign_config',
    component: function component() {
      return import('@/pages/sign_config/index');
    },
    meta: {
      auth: true,
      cache: true,
      title: '注册时间配置'
    }
  },
  //运动员管理
  {
    path: '/athletes',
    name: 'athletes',
    component: function component() {
      return import('@/pages/athletes/all');
    },
    meta: {
      auth: true,
      cache: true,
      title: '运动员资料'
    }
  },
  //未通过运动员管理
  {
    path: '/athletes_not_pass',
    name: 'athletes_not_pass',
    component: function component() {
      return import('@/pages/athletes/not_pass');
    },
    meta: {
      auth: true,
      cache: true,
      title: '未通过运动员'
    }
  },
  //待审核运动员
  {
    path: '/athletes_wait',
    name: 'athletes_wait',
    component: function component() {
      return import('@/pages/athletes/wait');
    },
    meta: {
      auth: true,
      cache: true,
      title: '待审核运动员'
    }
  },
  //待完善运动员
  {
    path: '/athletes_wait_perfect',
    name: 'athletes_wait_perfect',
    component: function component() {
      return import('@/pages/athletes/wait_perfect');
    },
    meta: {
      auth: true,
      cache: true,
      title: '待完善运动员'
    }
  },
  //省运动员添加
  {
    path: '/provincial_athletes_index',
    name: 'provincial_athletes',
    component: function component() {
      return import('@/pages/provincial_athletes/index');
    },
    meta: {
      auth: true,
      cache: true,
      title: '无归属运动员选择'
    }
  },
  //省运动员选择审核
  {
    path: '/provincial_athletes_status_index',
    name: 'provincial_athletes_status_index',
    component: function component() {
      return import('@/pages/provincial_athletes_status/index');
    },
    meta: {
      auth: true,
      cache: true,
      title: '运动员审核'
    }
  }, {
    path: '/provincial_athletes_status/save',
    name: 'provincial_athletes_status_save',
    component: function component() {
      return import('@/pages/provincial_athletes_status/save');
    },
    meta: {
      auth: true,
      cache: true,
      title: '运动员审核编辑'
    }
  },
  //运动员审核
  {
    path: '/athletes_reg_info',
    name: 'athletes_reg_info',
    component: function component() {
      return import('@/pages/athletes_reg_info/index');
    },
    meta: {
      auth: true,
      cache: true,
      title: '运动员审核'
    }
  }, {
    path: '/athletes_reg_info/save',
    name: 'athletes_reg_info_save',
    component: function component() {
      return import('@/pages/athletes_reg_info/save');
    },
    meta: {
      auth: true,
      cache: true,
      title: '运动员审核详情'
    }
  }, {
    path: '/athletes_reg_info/file',
    name: 'athletes_reg_file',
    component: function component() {
      return import('@/pages/athletes_reg_info/file');
    },
    meta: {
      auth: true,
      cache: true,
      title: '运动员注册汇总审核附件'
    }
  },
  //运动员迁移管理
  {
    path: '/athletes_replace',
    name: 'athletes_replace',
    component: function component() {
      return import('@/pages/athletes_replace/index');
    },
    meta: {
      auth: true,
      cache: true,
      title: '运动员变更注册单位管理'
    }
  }, {
    path: '/athletes_replace/save',
    name: 'athletes_replace_save',
    component: function component() {
      return import('@/pages/athletes_replace/save');
    },
    meta: {
      auth: true,
      cache: true,
      title: '运动员变更注册单位详情'
    }
  },
  //运动员换项管理
  {
    path: '/athletes_replace_project',
    name: 'athletes_replace_project',
    component: function component() {
      return import('@/pages/athletes_replace_project/index_s');
    },
    meta: {
      auth: true,
      cache: true,
      title: '运动员变更项目管理'
    }
  }, {
    path: '/athletes_replace_project/save',
    name: 'athletes_replace_project_save',
    component: function component() {
      return import('@/pages/athletes_replace_project/save');
    },
    meta: {
      auth: true,
      cache: true,
      title: '运动员变更项目详情'
    }
  },
  //运动员换学籍管理
  {
    path: '/athletes_replace_status',
    name: 'athletes_replace_status',
    component: function component() {
      return import('@/pages/athletes_replace_status/index');
    },
    meta: {
      auth: true,
      cache: true,
      title: '运动员变更学籍管理'
    }
  }, {
    path: '/athletes_replace_status/save',
    name: 'athletes_replace_status_save',
    component: function component() {
      return import('@/pages/athletes_replace_status/save');
    },
    meta: {
      auth: true,
      cache: true,
      title: '运动员变更学籍详情'
    }
  },
  //运动员操作日志
  {
    path: '/athletes_log',
    name: 'athletes_log',
    component: function component() {
      return import('@/pages/athletes_log/index');
    },
    meta: {
      auth: true,
      title: '运动员操作日志'
    }
  },
  //赛届管理
  {
    path: '/match_competition',
    name: 'match_competition',
    component: function component() {
      return import('@/pages/match_competition/index');
    },
    meta: {
      auth: true,
      cache: true,
      title: '赛届管理'
    }
  }, {
    path: '/match_competition/save',
    name: 'match_competition_save',
    component: function component() {
      return import('@/pages/match_competition/save');
    },
    meta: {
      auth: true,
      cache: true,
      title: '赛届编辑'
    }
  },
  //赛事管理
  {
    path: '/match',
    name: 'match',
    component: function component() {
      return import('@/pages/match/index');
    },
    meta: {
      auth: true,
      cache: true,
      title: '赛事管理'
    }
  }, {
    path: '/match/save',
    name: 'match_save',
    component: function component() {
      return import('@/pages/match/save');
    },
    meta: {
      auth: true,
      cache: true,
      title: '赛事编辑'
    }
  },
  //赛事项目管理
  {
    path: '/match_project',
    name: 'match_project',
    component: function component() {
      return import('@/pages/match_project/index');
    },
    meta: {
      auth: true,
      cache: true,
      title: '赛事项目管理'
    }
  }, {
    path: '/match_project/save',
    name: 'match_project_save',
    component: function component() {
      return import('@/pages/match_project/save');
    },
    meta: {
      auth: true,
      cache: true,
      title: '赛事项目编辑'
    }
  },
  //赛事小项管理
  {
    path: '/match_project_item',
    name: 'match_project_item',
    component: function component() {
      return import('@/pages/match_project_item/index');
    },
    meta: {
      auth: true,
      cache: true,
      title: '赛事小项管理'
    }
  }, {
    path: '/match_project_item/save',
    name: 'match_project_item_save',
    component: function component() {
      return import('@/pages/match_project_item/save');
    },
    meta: {
      auth: true,
      cache: true,
      title: '赛事小项编辑'
    }
  },
  //团队积分
  {
    path: '/match_achievement_team',
    name: 'match_achievement_team',
    component: function component() {
      return import('@/pages/match_achievement_team/index');
    },
    meta: {
      auth: true,
      cache: true,
      title: '团队积分'
    }
  },
  //积分管理
  {
    path: '/match_achievement_score_index',
    name: 'match_achievement_score_index',
    component: function component() {
      return import('@/pages/match_achievement_score/index');
    },
    meta: {
      auth: true,
      cache: true,
      title: '积分流水'
    }
  }, {
    path: '/converted_achievement',
    name: 'converted_achievement',
    component: function component() {
      return import('@/pages/converted_achievement/index');
    },
    meta: {
      auth: true,
      cache: true,
      title: '折算分统计'
    }
  }, {
    path: '/converted_achievement/save',
    name: 'converted_achievement_save',
    component: function component() {
      return import('@/pages/converted_achievement/save');
    },
    meta: {
      auth: true,
      cache: true,
      title: '折算分录入'
    }
  },
  //成绩管理
  {
    path: '/match_achievement',
    name: 'match_achievement',
    component: function component() {
      return import('@/pages/match_achievement/index');
    },
    meta: {
      auth: true,
      cache: true,
      title: '成绩查询'
    }
  }, {
    path: '/match_achievement/save',
    name: 'match_achievement_save',
    component: function component() {
      return import('@/pages/match_achievement/save');
    },
    meta: {
      auth: true,
      cache: true,
      title: '成绩录入'
    }
  },
  //成绩审核
  {
    path: '/match_achievement_info',
    name: 'match_achievement_info',
    component: function component() {
      return import('@/pages/match_achievement_info/index');
    },
    meta: {
      auth: true,
      cache: true,
      title: '成绩审核列表'
    }
  }, {
    path: '/match_achievement_info/save',
    name: 'match_achievement_info_save',
    component: function component() {
      return import('@/pages/match_achievement_info/save');
    },
    meta: {
      auth: true,
      cache: true,
      title: '成绩审核编辑'
    }
  },
  //秩序册管理
  {
    path: '/match_project_measurement',
    name: 'match_project_measurement',
    component: function component() {
      return import('@/pages/match_project_measurement/index');
    },
    meta: {
      auth: true,
      cache: true,
      title: '秩序册管理'
    }
  }, {
    path: '/match_project_measurement/save',
    name: 'match_project_measurement_save',
    component: function component() {
      return import('@/pages/match_project_measurement/save');
    },
    meta: {
      auth: true,
      cache: true,
      title: '秩序册素材管理'
    }
  },
  //赛事项目组别管理
  {
    path: '/match_group',
    name: 'match_group',
    component: function component() {
      return import('@/pages/match_group/index');
    },
    meta: {
      auth: true,
      cache: true,
      title: '项目组别管理'
    }
  }, {
    path: '/match_group/save',
    name: 'match_group_save',
    component: function component() {
      return import('@/pages/match_group/save');
    },
    meta: {
      auth: true,
      cache: true,
      title: '项目组别编辑'
    }
  },
  //组别配置
  {
    path: '/group',
    name: 'group',
    component: function component() {
      return import('@/pages/group/index');
    },
    meta: {
      auth: true,
      cache: true,
      title: '组别管理'
    }
  }, {
    path: '/group/save',
    name: 'group_save',
    component: function component() {
      return import('@/pages/group/save');
    },
    meta: {
      auth: true,
      cache: true,
      title: '组别编辑'
    }
  },
  //赛事名次管理
  {
    path: '/match_score_config',
    name: 'match_score_config',
    component: function component() {
      return import('@/pages/match_score_config/index');
    },
    meta: {
      auth: true,
      cache: true,
      title: '名次管理'
    }
  }, {
    path: '/match_score_config/save',
    name: 'match_score_config_save',
    component: function component() {
      return import('@/pages/match_score_config/save');
    },
    meta: {
      auth: true,
      cache: true,
      title: '名次编辑'
    }
  },
  //指纹类型管理
  {
    path: '/athletes_fingerprint_type',
    name: 'athletes_fingerprint_type',
    component: function component() {
      return import('@/pages/athletes_fingerprint_type/index');
    },
    meta: {
      auth: true,
      cache: true,
      title: '指纹类型管理'
    }
  }, {
    path: '/athletes_fingerprint_type/save',
    name: 'athletes_fingerprint_type_save',
    component: function component() {
      return import('@/pages/athletes_fingerprint_type/save');
    },
    meta: {
      auth: true,
      cache: true,
      title: '指纹类型编辑'
    }
  },
  //文章分类
  {
    path: '/article_type',
    name: 'article_type_index',
    component: function component() {
      return import('@/pages/article_type/index');
    },
    meta: {
      auth: true,
      title: '资讯分类'
    }
  }, {
    path: '/article_type/form',
    name: 'article_type_form',
    component: function component() {
      return import('@/pages/article_type/form');
    },
    meta: {
      auth: true,
      cache: true,
      title: '编辑资讯分类'
    }
  },
  //文章
  {
    path: '/article',
    name: 'article_index',
    component: function component() {
      return import('@/pages/article/index');
    },
    meta: {
      auth: true,
      title: '资讯管理'
    }
  }, {
    path: '/article/form',
    name: 'article_form',
    component: function component() {
      return import('@/pages/article/form');
    },
    meta: {
      auth: true,
      cache: true,
      title: '编辑资讯'
    }
  }, {
    path: '/article/detail',
    name: 'article_detail',
    component: function component() {
      return import('@/pages/article/detail');
    },
    meta: {
      auth: true,
      title: '资讯详情'
    }
  }, {
    path: '/article_check',
    name: 'article_check',
    component: function component() {
      return import('@/pages/article_check/index');
    },
    meta: {
      auth: true,
      title: '资讯列表'
    }
  }, {
    path: '/sys_info',
    name: 'sys_info',
    component: function component() {
      return import('@/pages/sys_info/index');
    },
    meta: {
      auth: true,
      title: '系统信息'
    }
  }, {
    path: '/api',
    name: 'api',
    component: function component() {
      return import('@/pages/api/index');
    },
    meta: {
      auth: true,
      title: '接口配置'
    }
  }, {
    path: '/app',
    name: 'app',
    component: function component() {
      return import('@/pages/app/index');
    },
    meta: {
      auth: true,
      title: 'app配置'
    }
  },
  //设备管理
  {
    path: '/device',
    name: 'device',
    component: function component() {
      return import('@/pages/device/index');
    },
    meta: {
      auth: true,
      title: '设备管理'
    }
  }, {
    path: '/device/form',
    name: 'device_form',
    component: function component() {
      return import('@/pages/device/form');
    },
    meta: {
      auth: true,
      cache: true,
      title: '编辑设备信息'
    }
  },
  //站内信、消息管理
  {
    path: '/message',
    name: 'message_index',
    component: function component() {
      return import('@/pages/message/index');
    },
    meta: {
      auth: true,
      title: '站内信管理'
    }
  }, {
    path: '/message/form',
    name: 'message_form',
    component: function component() {
      return import('@/pages/message/form');
    },
    meta: {
      auth: true,
      cache: true,
      title: '编辑站内信'
    }
  },
  //广告管理
  {
    path: '/advertisement',
    name: 'advertisement_index',
    component: function component() {
      return import('@/pages/advertisement/index');
    },
    meta: {
      auth: true,
      title: '广告管理'
    }
  }, {
    path: '/advertisement/form',
    name: 'advertisement_form',
    component: function component() {
      return import('@/pages/advertisement/form');
    },
    meta: {
      auth: true,
      cache: true,
      title: '编辑广告'
    }
  },
  //折算分配置管理
  {
    path: '/convert_config',
    name: 'convert_config_index',
    component: function component() {
      return import('@/pages/convert_config/index');
    },
    meta: {
      auth: true,
      title: '折算分配置管理'
    }
  }, {
    path: '/convert_config/form',
    name: 'convert_config_form',
    component: function component() {
      return import('@/pages/convert_config/form');
    },
    meta: {
      auth: true,
      cache: true,
      title: '编辑折算分配置'
    }
  },
  //最高纪录管理
  {
    path: '/previous_record',
    name: 'previous_record_index',
    component: function component() {
      return import('@/pages/previous_record/index');
    },
    meta: {
      auth: true,
      title: '最高纪录管理'
    }
  }, {
    path: '/previous_record/form',
    name: 'previous_record_form',
    component: function component() {
      return import('@/pages/previous_record/form');
    },
    meta: {
      auth: true,
      cache: true,
      title: '编辑最高纪录'
    }
  },
  //报到管理
  {
    path: '/check_in',
    name: 'check_in_index',
    component: function component() {
      return import('@/pages/check_in/index');
    },
    meta: {
      auth: true,
      title: '运动员报到管理'
    }
  },
  //奖状配置
  {
    path: '/award_config',
    name: 'award_config',
    component: function component() {
      return import('@/pages/award_config/index');
    },
    meta: {
      auth: true,
      cache: true,
      title: '奖状配置'
    }
  },
  //奖状打印日志
  {
    path: '/award_print_log',
    name: 'award_print_log',
    component: function component() {
      return import('@/pages/award_print_log/index');
    },
    meta: {
      auth: true,
      title: '奖状打印日志'
    }
  },
  //数据统计
  {
    path: '/statistics/select_match',
    name: 'statistics_select_match',
    component: function component() {
      return import('@/pages/statistics/select_match');
    },
    meta: {
      auth: true,
      title: '选择赛事'
    }
  }, {
    path: '/statistics/point_statistics',
    name: 'statistics_point_statistics',
    component: function component() {
      return import('@/pages/statistics/point_statistics');
    },
    meta: {
      auth: true,
      title: '积分统计'
    }
  }, {
    path: '/statistics/achievement',
    name: 'statistics_achievement',
    component: function component() {
      return import('@/pages/statistics/achievement');
    },
    meta: {
      cache: true,
      auth: true,
      title: '成绩查询'
    }
  }, {
    path: '/statistics/point_order',
    name: 'statistics_point_order',
    component: function component() {
      return import('@/pages/statistics/point_order');
    },
    meta: {
      auth: true,
      title: '积分排行'
    }
  }, {
    path: '/statistics/check_in',
    name: 'statistics_check_in',
    component: function component() {
      return import('@/pages/statistics/check_in');
    },
    meta: {
      auth: true,
      title: '报到统计'
    }
  },
  //赛事报名
  {
    path: '/sign_up/index',
    name: 'sign_up_index',
    component: function component() {
      return import('@/pages/sign_up/index');
    },
    meta: {
      auth: true,
      title: '赛事报名列表'
    }
  }, {
    path: '/sign_up/form',
    name: 'sign_up_form',
    component: function component() {
      return import('@/pages/sign_up/form');
    },
    meta: {
      auth: true,
      cache: true,
      title: '赛事报名'
    }
  }, {
    path: '/sign_up/confirm',
    name: 'sign_up_confirm',
    component: function component() {
      return import('@/pages/sign_up/confirm');
    },
    meta: {
      auth: true,
      cache: true,
      title: '报名提交'
    }
  }, {
    path: '/sign_up_audit/statistics',
    name: 'sign_up_audit_statistics',
    component: function component() {
      return import('@/pages/sign_up_audit/statistics');
    },
    meta: {
      auth: true,
      title: '报名审核列表'
    }
  }, {
    path: '/sign_up_audit',
    name: 'sign_up_audit_index',
    component: function component() {
      return import('@/pages/sign_up_audit/index');
    },
    meta: {
      auth: true,
      title: '报名审核列表'
    }
  }, {
    path: '/sign_up_audit/save',
    name: 'sign_up_audit_save',
    component: function component() {
      return import('@/pages/sign_up_audit/save');
    },
    meta: {
      auth: true,
      cache: true,
      title: '报名审核'
    }
  },
  //报名详情
  {
    path: '/sign_up_detail',
    name: 'sign_up_detail',
    component: function component() {
      return import('@/pages/sign_up_detail/index');
    },
    meta: {
      auth: true,
      title: '赛事报名详情'
    }
  },
  //赛事报名列表
  {
    path: '/sign_up_detail_list',
    name: 'sign_up_detail_list',
    component: function component() {
      return import('@/pages/sign_up_detail_list/index');
    },
    meta: {
      auth: true,
      title: '赛事报名列表'
    }
  },
  //报名队伍详情
  {
    path: '/sign_up_detail_list/list',
    name: 'sign_up_detail_list_list',
    component: function component() {
      return import('@/pages/sign_up_detail_list/list');
    },
    meta: {
      auth: true,
      title: '报名队伍详情'
    }
  },
  //报名表详情
  {
    path: '/sign_up_detail_list/detail',
    name: 'sign_up_detail_list_detail',
    component: function component() {
      return import('@/pages/sign_up_detail_list/detail');
    },
    meta: {
      auth: true,
      title: '报名表详情'
    }
  },
  // 系统 前端日志
  {
    path: 'log',
    name: 'log',
    meta: {
      title: '前端日志',
      auth: true
    },
    component: _import('system/log')
  },
  // 刷新页面 必须保留
  {
    path: 'refresh',
    name: 'refresh',
    hidden: true,
    component: _import('system/function/refresh')
  },
  // 页面重定向 必须保留
  {
    path: 'redirect/:route*',
    name: 'redirect',
    hidden: true,
    component: _import('system/function/redirect')
  }]
}];

/**
 * 在主框架之外显示
 */
var frameOut = [
// 登录
{
  path: '/login',
  name: 'login',
  component: _import('system/login')
}];

/**
 * 错误页面
 */
var errorPage = [{
  path: '*',
  name: '404',
  component: _import('system/error/404')
}];

// 导出需要显示菜单的
export var frameInRoutes = frameIn;

// 重新组织后导出
export default [].concat(frameIn, frameOut, errorPage);